import "~/misc/common";
import DeviceBase from "./device_base";
import { ChartTemperature } from "./chart_temperature";
import { GaugeTemperature } from "./gauge_temperature";

export default class extends DeviceBase {
	connect() {
		const controller = this;

		this.connectBase({
			channel: "ThermostatUiChannel",
			onConnection: (connected) => {
				if (connected) controller.sendCmd('?');
			},
			onEvent: (msg: string) => {
				if (msg.startsWith('temp.')) {
					temperature(msg.replace('temp.', ''));
				}
				if (msg.startsWith('selected_thermometer_id=')) {
					$('#state_selected_thermometer_id').val(msg.replace('selected_thermometer_id=', '')).trigger('change.select2');
				}
				if (msg.startsWith('max_program=')) {
					max_program(msg.replace('max_program=', ''));
				}
				if (msg.startsWith('program=')) {
					program(msg.replace('program=', ''));
				}
				if (msg.startsWith('btn.')) {
					btn(msg.replace('btn.', ''));
				}
			}
		});

		const el = this.element as HTMLDivElement;
		const thermometers = JSON.parse(el.dataset.thermometers!);
		console.log(thermometers);

		function temperature(msg: string) {
			const parts = msg.split("=");
			const temp = parseFloat(parts[1]) / 10.0;
			const mac = parts[0];
			gauges.updateGauge(mac, temp);
		}

		let maxProgram = 0;
		function max_program(msg: string) {
			maxProgram = parseInt(msg);
			$('#program').empty();
			for (let i = 0; i < maxProgram; i++) {
				$('#program').append('<button class="btn btn-default btn-program" id="program' + i + '">P' + (i + 1) + '</button>');
			}
			$('.btn-program').on('click', function () {
				$('.btn-program').removeClass('active');
				$(this).addClass('active');
				$(this).blur();
				controller.sendCmd('program=' + $(this)[0].id.substring(7));
			});
			controller.sendCmd('program?');
		}

		function program(msg: string) {
			$('.btn-program').removeClass('active');
			$('#program' + msg).addClass('active');
		}

		function btn(msg: string) {
			const parts = msg.split("=");
			if (parts[1] == '0') {
				$('#btn' + parts[0]).removeClass('active');
			} else {
				$('#btn' + parts[0]).addClass('active');
			}
		}

		$('#state_selected_thermometer_id').on('change', function () {
			controller.sendCmd('selected_thermometer_id=' + $('#state_selected_thermometer_id').val());
		});

		// TEMPERATURE GAUGE
		const gauges = new GaugeTemperature(thermometers);

		//LINE CHART
		const chart = new ChartTemperature('#line', controller.mac_address);

	}
}
